import React from 'react';
import Icon from '../../../components/AppIcon';

const FormProgressIndicator = ({ 
  currentStep, 
  totalSteps, 
  steps,
  className = '' 
}) => {
  return (
    <div className={`bg-card border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-foreground">Report Progress</h3>
        <span className="text-xs text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
      </div>
      <div className="space-y-3">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isPending = stepNumber > currentStep;

          return (
            <div key={step?.id} className="flex items-center space-x-3">
              {/* Step Icon */}
              <div className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium ${
                isCompleted 
                  ? 'bg-success text-success-foreground' 
                  : isCurrent 
                    ? 'bg-primary text-primary-foreground' 
                    : 'bg-muted text-muted-foreground'
              }`}>
                {isCompleted ? (
                  <Icon name="Check" size={12} />
                ) : (
                  stepNumber
                )}
              </div>
              {/* Step Content */}
              <div className="flex-1">
                <p className={`text-sm font-medium ${
                  isCurrent ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {step?.title}
                </p>
                {isCurrent && (
                  <p className="text-xs text-muted-foreground mt-1">
                    {step?.description}
                  </p>
                )}
              </div>
              {/* Status Icon */}
              {isCurrent && (
                <Icon name="ArrowRight" size={14} className="text-primary" />
              )}
            </div>
          );
        })}
      </div>
      {/* Progress Bar */}
      <div className="mt-4">
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default FormProgressIndicator;